export default {
  props: {
    collections: {
      type: Array,
      default: () => [],
    },
  },
};
